import styled, { css } from "styled-components";

import { NexusDropdownContent } from "pages/[tenant]/g/[group_slug]/classwork/components/templates/ClassworkPageImersiveLayout/components/molecules/GroupNexusContent/styles";

export const ClassworkDropdownTitle = styled.div`
  font: 600 1.125rem/1.6875rem "Inter";
  color: ${({ theme }) => theme.classwork.imersive.dropdownTitle};

  display: flex;
  align-items: center;
  gap: 12px;

  border: none;
  background: transparent;
  height: 30px;

  width: fit-content;

  .dropdown-title {
    width: 100%;
  }

  :hover {
    cursor: pointer;
  }

  @media (max-width: 500px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const ClassworkDropdownContent = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(190px, 275px));
  gap: 1.4375rem;

  margin: 0;

  max-height: 0px;
  overflow-y: auto;
  overflow-x: hidden;
  transition: 0.5s all;

  scroll-behavior: smooth;

  > .loader {
    width: fit-content;
    margin: 0.5rem auto 1rem auto;
  }

  @media (max-width: 1100px) {
    grid-template-columns: repeat(4, minmax(100px, 275px));
  }

  @media (max-width: 850px) {
    grid-template-columns: repeat(3, minmax(100px, 275px));
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }

  li {
    list-style: none;
  }

  .empty-message,
  .error-message {
    grid-column: 1/ -1;

    color: ${({ theme }) => (theme.mode === "dark" ? "#C8C8C9" : "#666666")};
    font: 500 14px/24.8px "Inter";
    font-style: italic;

    text-align: center;
  }
`;

interface IClassworkDropdownContainerProps {
  isDropdownOpen: boolean;
  totalLessons: number;
}

export const ClassworkDropdownContainer = styled.div<IClassworkDropdownContainerProps>`
  ${({ isDropdownOpen, totalLessons }) =>
    isDropdownOpen &&
    css`
      ${ClassworkDropdownTitle} {
        svg.classwork-dropdown-arrow {
          transform: rotate(180deg);
        }
      }

      ${ClassworkDropdownContent}, ${NexusDropdownContent} {
        transition: 0.4s max-height ease-in;
        max-height: calc(${totalLessons} * 300px);
      }

      ${ClassworkDropdownContent} {
        margin-top: 1.5rem;
      }
    `}

  svg.classwork-dropdown-arrow {
    transition: 0.3s ease-in-out;
  }

  .image {
    height: 154px;
    width: 273px;
    background-color: red;
  }
`;
